const ValidLocales = [
    'en-US',
    'en-AU',
    'en-GB',
    'fr-FR',
    'fr-CA',
    'fr-CH',
    'de-DE',
    'en-CA',
    'en-NZ',
    'en-SG',
    'en-IE',
    'de-AT',
    'de-CH',
    'en-IN',
    'it-IT',
    'nl-NL',
    'nl-BE',
    'fr-BE',
    'es-ES',
    'es-US',
    'it-CH',
    'pt-PT',
    'nb-NO',
    'da-DK',
    'sv-SE',
    'fi-FI',
] as const;

export default ValidLocales;
